{
  "app_name": "金数据客户端 Testing",
  "ios": {
    "CFBundleDisplayName": "金数据 Testing"
  }
}
